var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrokeIconDance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5448 3.31957L18.9334 8.93091V5.85956C18.9334 2.89528 16.5299 0.5 13.5738 0.5H13.0738V1V8.93091L10.8983 6.75541C8.8072 4.66426 5.41072 4.66426 3.31957 6.75541L2.96602 7.10896L3.31957 7.46251L8.93091 13.0739H5.85956C2.89528 13.0739 0.5 15.4774 0.5 18.4334V18.9334H1H8.92364L6.74814 21.1089C4.657 23.2001 4.657 26.5965 6.74814 28.6877L7.1017 29.0412L7.45525 28.6877L13.0666 23.0764V26.1477C13.0666 29.112 15.4701 31.5073 18.4262 31.5073H18.9262V31.0073V23.0764L21.1017 25.2519C23.1928 27.343 26.5893 27.343 28.6804 25.2519L29.034 24.8983L28.6804 24.5448L23.0691 18.9334H26.1404C29.1047 18.9334 31.5 16.5299 31.5 13.5739V13.0739H31H23.0764L25.2519 10.8983C27.343 8.8072 27.343 5.41072 25.2519 3.31957L24.8983 2.96602L24.5448 3.31957Z",
    fill: "#C071FF",
    stroke: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeIconDance);
export default __webpack_public_path__ + "static/media/stroke-icon-dance.a6a1a98b53673766d5ad4125cd591ce2.svg";
export { ForwardRef as ReactComponent };